import React, { useLayoutEffect, useRef, useState } from 'react';

import { Tooltip } from 'antd';

const TEXT_PROP_ERROR = 'EllipsisWithTooltip: "text" prop is required.';

/** This component is used to display a text with a tooltip when the text is too long. */
/**
 * @param {string} text - The text to display.
 * @returns {React.ReactNode} - The component.
 */
const EllipsisWithTooltip = ({ text }) => {
  if (text === undefined || text === null) {
    throw new Error(TEXT_PROP_ERROR);
  }

  const ref = useRef(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
  
    const checkOverflow = () => {
      setIsOverflowed(el.scrollWidth - el.clientWidth > 1);
    };
  
    checkOverflow();
  }, [text]);

  const content = (
    <div
      ref={ref}
      style={{
        width: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      <strong>{text}</strong>
    </div>
  );

  return isOverflowed ? (
    <Tooltip title={text}>
      {content}
    </Tooltip>
  ) : (
    content
  );
};

export default EllipsisWithTooltip;